import { Message } from "../types";

export function makeMessages<T extends { [name: string]: Message | Message[] }>(
  messages: T
) {
  return messages;
}
